import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { DataEntryAttachmentDescriptor } from './model/dataentry';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DataEntryAttachmentService extends RESTServiceBase {
  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'DataEntryAttachmentManagement',
      authService,
      config.DEAMSConfig
    );
  }

  public create(DataEntryAttachment: DataEntryAttachmentDescriptor): Promise<DataEntryAttachmentDescriptor> {
    return super.post<DataEntryAttachmentDescriptor>(
      new DataEntryAttachmentDescriptor({
        id: undefined,
        href: undefined,
        dataEntryId: DataEntryAttachment.dataEntryId,
        alias: DataEntryAttachment.alias,
        size: DataEntryAttachment.size,
        body: DataEntryAttachment.body,
        createdById: DataEntryAttachment.createdById,
        createdOn: DataEntryAttachment.createdOn,
        modified: DataEntryAttachment.modified,
        deleted: DataEntryAttachment.deleted
      }));
  }

  public getDataEntryAttachments(view?: View): Promise<List<DataEntryAttachmentDescriptor>> {
    return super.get<List<DataEntryAttachmentDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, DataEntryAttachment: DataEntryAttachmentDescriptor): Promise<DataEntryAttachmentDescriptor> {
    return super.put<DataEntryAttachmentDescriptor>(id, DataEntryAttachment);
  }

  public getById(id: string): Promise<DataEntryAttachmentDescriptor> {
    return super.get<DataEntryAttachmentDescriptor>(id);
  }

  public upload(id: string, files: Set<File>): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id) + '/upload', files);
  }

  public download(id: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/download');
  }

  public uploadExternal(id: string, reference: any, blobalias: string, file: File): any {
    var fileprogress = { id: id, name: file.name, inprogress: true, percentage: 0, error: undefined, observable: undefined, subscription: undefined };
    this.auth.uploadProgress.push(fileprogress);

    var obs = this.auth.uploadExternalFile(this.buildUrl(id) + '/uploadblob', file, id, reference, blobalias,
       (id) => { 
        fileprogress.error = fileprogress.percentage ? undefined : "Ismeretlen hiba";
        fileprogress.inprogress = false;
        fileprogress.subscription.unsubscribe();
       }, 
       (id, error) => { 
        fileprogress.error = error;
        fileprogress.inprogress = false;
        fileprogress.subscription.unsubscribe();
       }
      
    );

    fileprogress.observable = obs;
    fileprogress.subscription = obs.subscribe(
      (value) => { 
        fileprogress.percentage = value;
      },
      (error) => {
        fileprogress.error = error;
        fileprogress.inprogress = false;
        fileprogress.subscription.unsubscribe();
      },
      () => {
        fileprogress.error = fileprogress.percentage ? undefined : "Ismeretlen hiba";
        fileprogress.percentage = fileprogress.percentage ? 100 : 0;
        fileprogress.inprogress = false;
        fileprogress.subscription.unsubscribe();
      });

    var status: any = {};
    status[file.name] = {
        progress: fileprogress.observable.asObservable()
      };

    return status;
  }

  public downloadExternal(id: string, reference: any, blobalias: string): Promise<Blob> {
    return this.auth.downloadExternalFile(this.buildUrl(id) + '/downloadblob', reference, blobalias);
  }

  public deleteExternal(id: string, reference: any, blobalias: string): Promise<void> {
    return this.auth.deleteExternalFile(this.buildUrl(id, "blob"), reference, blobalias);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry/dataentry.attachment.service.ts